/* eslint-disable @typescript-eslint/no-unused-vars */
'use client'

import Image from 'next/image'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    // global-error must include html and body tags
    <html lang="vi">
      <head>
        <title>500 - Error</title>
      </head>
      <body className="bg-gray-100 flex items-center justify-center h-screen">
        <div className="h-[50vh] flex items-center justify-center flex-col">
          <Image src="/assets/images/404.jpg" alt="not found" width={400} height={400} className="w-[80%] max-w-md grayscale mx-auto" unoptimized />
          <div className="text-center mt-3 space-y-1">
            <p className="text-xl font-bold text-black">Đã có lỗi xảy ra</p>
            <p className="text-base text-gray-600">Xin lỗi vì sự bất tiện này. Chúng tôi sẽ khắc phục sớm nhất.</p>
            <a href="/" className="inline-block mt-4 px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
              Về trang chủ
            </a>
          </div>
        </div>
      </body>
    </html>
  )
}
